import { render } from "./StoryCommentMessage.vue.js?vue&type=template&id=f3d01d30!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentMessage.vue?vue&type=template&id=f3d01d30"
import script from "./StoryCommentMessage.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentMessage.vue?vue&type=script&lang=js"
export * from "./StoryCommentMessage.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/story-comment/StoryCommentMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f3d01d30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f3d01d30', __exports__)) {
    api.reload('f3d01d30', __exports__)
  }
  
  module.hot.accept("./StoryCommentMessage.vue.js?vue&type=template&id=f3d01d30!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentMessage.vue?vue&type=template&id=f3d01d30", () => {
    api.rerender('f3d01d30', render)
  })

}


export default __exports__